
import { CommandType } from "~app/common/services/cqs/CommandType";
import { VKAvtalEditDTO } from "../../models/avtal-models";
import { AvtalCommandBase } from "./AvtalCommandBase";

export class UpdateAvtalCommand extends AvtalCommandBase {
    avtal: VKAvtalEditDTO;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAvtalCommand";

    constructor(avtal: VKAvtalEditDTO) {
        super(avtal.guid, UpdateAvtalCommand.$type, CommandType.Replace);
        this.avtal = avtal;
    }
}
